module.exports = __webpack_public_path__ + "images/deliveryMan_0a8bdc6.svg";